import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Grid } from '@mui/material';
import { useState } from 'react';

import { EstadosRubroChoiceEnum, TipoRubroChoiceEnum } from '@/shared';
import {
  AnularRubroData,
  useDeleteRubro,
  useUpdateRubro,
} from '@/shared/actions/erp';
import { SingleIconButton } from '@/shared/components/ui';
import { Contrato, Rubro } from '@/shared/interfaces';
import { useRecaudacionesStore } from '@/store/erp/recaudaciones';
import { useUiConfirmModalStore } from '@/store/ui';
import {
  ClienteRuboLibreModal,
} from '../../form/rubros';
import ClienteRubroAddPaymentModal from './ClienteRubroAddPaymentModal';

export type ClienteRubroActionBtnsProps = {
  rubro: Rubro;
  contract: Contrato;
};

const ClienteRubroActionBtns: React.FC<ClienteRubroActionBtnsProps> = ({
  rubro,
  contract,
}) => {
  const rubroState = rubro?.estado_rubro;

  ///* local state -------------------------
  const [openEditRubro, setOpenEditRubro] = useState<boolean>(false);
  const [openAddPayment, setOpenAddPayment] = useState(false);
  const [openEditRubroServicio, setOpenEditRubroServicio] = useState(false);

  ///* global state -------------------------
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  ///* global state -------------------------
  const setCurrentRubro = useRecaudacionesStore(state => state.setCurrentRubro);

  ///* mutations -------------------------
  const deleteRubro = useDeleteRubro();
  const updateRubro = useUpdateRubro<AnularRubroData>({
    enableRedirect: false,
    customSuccessMessage: 'Rubro anulado correctamente',
  });

  return (
    <>
      {rubroState === EstadosRubroChoiceEnum.NO_PAGADO ||
        rubroState === EstadosRubroChoiceEnum.PAGO_INCOMPLETO ? (
        <>
          <Grid item container xs={12} spacing={0}>
            <SingleIconButton
              startIcon={<CheckIcon />}
              color="success"
              label="Agregar Pago"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: 'Agregar pago',
                  subtitle: `¿Está seguro de agregar un pago al rubro ${rubro?.numero_referencia}?`,
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    setCurrentRubro(rubro);
                    setOpenAddPayment(true);
                  },
                  onClose: () => {
                    setConfirmDialogIsOpen(false);
                  },
                });
              }}
            />

            {/* only edit if there aren't any payment */}
            {rubroState === EstadosRubroChoiceEnum.NO_PAGADO && (
              <SingleIconButton
                startIcon={<EditIcon />}
                color="inherit"
                label="Editar rubro"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: 'Editar rubro',
                    subtitle: `¿Está seguro de editar el rubro ${rubro?.numero_referencia}?`,
                    onConfirm: () => {
                      setConfirmDialogIsOpen(false);

                      // rubro libre or rubro servicio
                      if (rubro?.tipo_rubro === TipoRubroChoiceEnum.LIBRE) {
                        setCurrentRubro(rubro);
                        setOpenEditRubro(true);
                      }
                      if (rubro?.tipo_rubro === TipoRubroChoiceEnum.SERVICIO) {
                        setCurrentRubro(rubro);
                        setOpenEditRubroServicio(true);
                      }
                    },
                    onClose: () => {
                      setConfirmDialogIsOpen(false);
                    },
                  });
                }}
                noThemeColor
              />
            )}

            <SingleIconButton
              startIcon={<PictureAsPdfIcon />}
              color="inherit"
              label="Ver PDF"
              onClick={() => {
                console.log('ver pdf');
              }}
              noThemeColor
            />

            {rubroState === EstadosRubroChoiceEnum.NO_PAGADO && (
              <SingleIconButton
                startIcon={<DeleteIcon />}
                color="inherit"
                label="Eliminar"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: `Eliminar rubro ${rubro?.numero_referencia}`,
                    subtitle: `Si el rubro contiene productos agregados, estos serán restaurados en el inventario.

                Saldos agregados a esta factura volverán a estar pendientes`,
                    onConfirm: () => {
                      setConfirmDialogIsOpen(false);
                      // TODO: eliminar rubro back additionaly logic

                      deleteRubro.mutate(rubro?.id_rubro!);
                    },
                    onClose: () => {
                      setConfirmDialogIsOpen(false);
                    },
                  });
                }}
                noThemeColor
              />
            )}


            <SingleIconButton
              startIcon={<DoNotDisturbIcon />}
              color="inherit"
              label="Anular"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: `Anular rubro ${rubro?.numero_referencia}`,
                  subtitle:
                    'Si el rubro contiene productos agregados, estos serán restaurados en el inventario.',
                  onConfirm: () => {
                    updateRubro.mutate({
                      id: rubro?.id_rubro!,
                      data: {
                        estado_rubro: EstadosRubroChoiceEnum.ANULADO,
                      },
                    });
                  },
                  onClose: () => {
                    setConfirmDialogIsOpen(false);
                  },
                });
              }}
              noThemeColor
            />
          </Grid>
        </>
      ) : rubroState === EstadosRubroChoiceEnum.PAGADO ? (
        <>
          <Grid item container xs={12} spacing={0}>
            <SingleIconButton
              startIcon={<PictureAsPdfIcon />}
              color="inherit"
              label="Ver PDF"
              onClick={() => {
                alert('ver pdf');
              }}
              noThemeColor
            />
          </Grid>
        </>
      ) : rubroState === EstadosRubroChoiceEnum.VENCIDO ? (
        <>VENCIDO BTNS</>
      ) : rubroState === EstadosRubroChoiceEnum.ANULADO ? (
        <>
          <SingleIconButton
            startIcon={<PictureAsPdfIcon />}
            color="inherit"
            label="Ver PDF"
            onClick={() => {
              console.log('ver pdf');
            }}
            noThemeColor
          />
        </>
      ) : null}

      {/* ================ modals ================ */}
      {/* ------- add payment - transaccion ------- */}
      <ClienteRubroAddPaymentModal
        open={openAddPayment}
        onClose={() => setOpenAddPayment(false)}
      />

      {/* ------- edit rubro ------- */}
      <ClienteRuboLibreModal
        contract={contract}
        open={openEditRubro}
        setOpen={setOpenEditRubro}
      />
    </>
  );
};

export default ClienteRubroActionBtns;
